import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 碎片组件
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';

// 组件
import Header from './Header';
import Navigation from './Navigation';
import Meteorological from './Meteorological';
import FocusNews from './FocusNews';
import Media from './Media';
import Footer from './Footer';
// 左栏模块
// 轮播组件
// Hooks自写
// import Slider from './Slider';
// class完整
import SliderComponent from './SliderComponent';

// 右栏模块
import Speech from './Speech';
import Activity from './Activity';
import VideoPoster from './VideoPoster';
import Enterprise from './Enterprise';
import Government from './Government';
import Partner from './Partner';
// 样式
import styles from './index.css';

const Layout = ({ content }) => {
  
    const {
        base, 
        slider,
        navigation,
        activity,
        activityTitle,
        enterprise,
        enterpriseTitle,
        focusNews,
        focusNewsTitle,
        government,
        governmentTitle,
        media,
        mediaTitle,
        meteorological,
        meteorologicalTitle,
        partner,
        partnerTitle,
        speech,
        speechTitle,
        video,
        videoTitle,
        footer
        } = content;

    // 头部数据
    const headerData = {
        logo: base.logo,
    };
  
    // 轮播图必穿配置（自定义写死）
    const componentOptions = {
        extendData: '',
        length: 5
    };

    // 底部信息配置
    const footerData = {
        bottomAd: content.bottomAd,
        footer: content.footer,
        isBiz: content.isBiz,
    };

return (
        <div className={styles.layout_test}>
            <Header content={headerData} />
            {/* 通用列表 */}
            <Chip
                key="navigation"
                id="260155"
                name="navigation"
                type="struct"
                title="通用列表"
                groupName="通用列表"
                content={navigation}
            >
                <Navigation />
            </Chip>
            <div className={styles.main}>
                <div className={styles.container}>
                    <div className={styles.colLeft}>
                        {/* 轮播图 */}
                        <Chip 
                            key="slider"
                            id="285743"
                            name="slider"
                            type="recommend"
                            title="轮播图"
                            groupName="轮播图"
                            content={slider}
                        >
                            {/* <Slider /> */}
                            <SliderComponent componentOptions={componentOptions} />
                        </Chip>
                         {/* 气象现实项目 */}
                         <Meteorological content={{ meteorological, meteorologicalTitle }} />
                        {/* 双碳要闻 */}
                        <FocusNews content={{ focusNews, focusNewsTitle }} />
                        {/* 媒体合作伙伴 */}
                        <Media content={{ media, mediaTitle }} />

                    </div>
                    <div className={styles.colRight}>
                        {/* 名家言论 */}
                        <Speech content={{ speech, speechTitle }} />
                
                        {/* 活动专区 */}
                        <Activity content={{ activity, activityTitle }} />    

                        {/* 视频栏目 */}
                        <VideoPoster content={{ video, videoTitle }} />
                        {/* 优秀企业 */}
                        <Enterprise content={{ enterprise, enterpriseTitle }} />

                        {/* 优秀地方政府 */}
                        <Government content={{ government, governmentTitle }} />

                        {/* 合作伙伴 */}
                        <Partner content={{ partner, partnerTitle }} />
           
                    </div>
                </div>
            </div>
            <div className={styles.container}>
                <Footer content={footerData} />
            </div>
            
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
